import agreementsDictionary from '@features/agreements/i18n/ru/agreements.dic.json';

export const agreements = {
  AGREEMENTS: agreementsDictionary,
};

export const agreementsNamespaces = ['AGREEMENTS'];
